import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { uniq } from 'lodash';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import getInitialState from '../get-initial-state';
import actions from '../actions';
import { actionCreators, actionTypes } from './actions';

const moment = extendMoment(Moment);

function* reset() {
  const { assets } = yield select((state) => state);

  const assetTypes = uniq(assets.data.map((item) => item.asset.type));
  const categories = uniq(assets.data.map((item) => item.category));
  const makes = uniq(assets.data.map((item) => item.asset.make));

  const auditFilters = {
    ...getInitialState.auditFilters(),
    assetTypes,
    categories,
    makes,
  };

  yield put(actionCreators.set(auditFilters));
}

function* setAuditAssets(action) {
  const { auditFilters } = action.payload;
  const { assets, auditsCreate } = yield select((state) => state);
  
  const next = assets.data.filter((item) => item.isLive).map((item) => {
    let isExpected = true;
    let isMandatory = item.isRelated;
    if (isMandatory) {
      if (item.excludeFrom && item.excludeUntil) {
        const auditSchedule = moment.range(auditsCreate.startDate, auditsCreate.endDate);
        const excludeRange = moment.range(item.excludeFrom, item.excludeUntil);
        isExpected = !auditSchedule.overlaps(excludeRange);
      }
      isMandatory = (
        auditFilters.assetTypes.includes(item.asset.type)
        && auditFilters.categories.includes(item.category)
        && auditFilters.makes.includes(item.asset.make)
      );
    }
    return { ...item, isExpected, isMandatory };
  });

  yield put(actions.auditAssets.create.set(next));
  yield put(actions.auditsCreate.create.summary());
}

export default function* () {
  yield all([
    takeLatest(actionTypes.AUDIT_FILTERS_RESET, reset),
    takeLatest(actionTypes.AUDIT_FILTERS_SET, setAuditAssets),
  ]);
}
